import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_shrtn_passphrase_invalid = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Invalid secret`;
  }
);
const de_shrtn_passphrase_invalid = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Ungültiges Kennwort`;
  }
);
const sp_shrtn_passphrase_invalid = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Contraseña inválida`;
  }
);
const shrtn_passphrase_invalid = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_passphrase_invalid", locale);
  if (locale === "en") return en_shrtn_passphrase_invalid();
  if (locale === "de") return de_shrtn_passphrase_invalid();
  return sp_shrtn_passphrase_invalid();
};
export {
  shrtn_passphrase_invalid as s
};
